import AbstractComponent from './AbstractComponent';

class RichText extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  // bind() {
  // 	super.bind();
  // }

  // getUI() {
  // 	const ui = super.getUI();
  // 	return ui;
  // }

  // events(listen) {
  // 	const listener = listen ? 'addEventListener' : 'removeEventListener';
  // }

  initializeBeforeEvents() {
    this.buildFigures();
  }

  buildFigures() {
    const $images = [...this.$element.querySelectorAll('img')];
    $images.forEach(($img) => {
      const alt = $img.getAttribute('alt');
      if (alt) {
        const html = $img.outerHTML;
        $img.outerHTML = `
					<figure class="figure">
						${html}
						<figcaption>${alt}</figcaption>
					</figure>
				`;
      }
    });
  }
}

export default RichText;
